const authStore = {
  namespaced: true,
  state: {
    user: null,
    // token: getCookie('auth_token') || null
  },
  mutations: {
    SET_USER(state, user) {
      state.user = user
    },
    // SET_TOKEN(state, token) {
    //   state.token = token
    //   if (token) {
    //     setCookie('auth_token', token, 7) 
    //   } else {
    //     deleteCookie('auth_token')
    //   }
    // }
  },
  actions: {
    login({ commit }, {user}) {
      commit('SET_USER', user)
    },
    logout({ commit }) {
      commit('SET_USER', null)
    },
    checkIn({ commit }, buyer) {
        commit('SET_USER', buyer)
        // commit('SET_TOKEN', token)

      // const token = getCookie('auth_token')
      // if (token && token !== state.token) {
      //   commit('SET_TOKEN', token)
      //   return true
      // }
      // return !!state.token
    }
  },
  getters: {
    currentUser: state => state.user
  }
}

export default authStore